if (!customElements.get('trustpilot-rating-widget') && !customElements.get('trustpilot-review-widget-1') && !customElements.get('testimonials-reviews')) {

  class TrustpilotWidget extends HTMLElement {
    constructor() {
      super();

      this.reviews = [];
      this.reviewsNextPage = null;

      this.init = new Promise((resolve) => {
        const globalTrustScore = sessionStorage.getItem('global-trust-score');
        const businessUnitId = sessionStorage.getItem('business-unit-id');
        if (!globalTrustScore || !businessUnitId) {
          fetch(`https://api.trustpilot.com/v1/business-units/find?name=${window.trustpilot.websiteUrl}&apikey=${window.trustpilot.apiKey}`)
            .then(response => response.json())
            .then(data => data.score && data.id && this.storageSet('global-trust-score', JSON.stringify(data)) && this.storageSet('business-unit-id', data.id) && this.setBusinessUnitId(data.id) && resolve(true));
        } else {
          this.setBusinessUnitId(businessUnitId);
          resolve(true);
        }
      });
    }

    getReviews(targetCount = null) {
      return new Promise((resolve, reject) => {
        let url = `https://api.trustpilot.com/v1/business-units/${window.trustpilot.businessUnitId}/reviews?apikey=${window.trustpilot.apiKey}`;
        if ((targetCount && this.reviews.length >= targetCount) || (this.reviews.length > 0 && !this.reviewsNextPage)) {
          resolve([]);
        } else {
          if (this.reviews.length > 0 && this.reviewsNextPage) {
            url = `${this.reviewsNextPage.href}&apikey=${window.trustpilot.apiKey}`;
            this.reviewsNextPage = null;
          }
          fetch(url)
            .then(response => response.json())
            .then(data => {
              if (data && data.reviews) {
                this.reviews.push(...data.reviews.map(r => { return { ...r, createdAtDate: Date.parse(r.createdAt) } }));
                this.reviews = this.reviews.filter((r) => r.stars > 1)
                this.reviews = this.sortReviewsByRating(this.reviews);
                this.reviewsNextPage = data.links && data.links.find(l => l.rel === "next-page");
                if (this.reviewsNextPage === undefined)
                  this.reviewsNextPage = null;
                if (targetCount && this.reviews.length < targetCount && this.reviewsNextPage)
                  this.getReviews(targetCount).then(r => resolve(this.sortReviewsByRating([...data.reviews, ...r])));
                else {
                  resolve(this.sortReviewsByRating(data.reviews));
                }
              } else {
                resolve([]);
              }
            })
            .catch(e => {
              console.error(e);
              reject(e);
            });
        }
      });
    }

    sortReviewsByRating(reviews) {
      reviews = reviews.filter(r => r.stars > 2);
      reviews.sort((a, b) => {
        if (b.stars < 5 && (!this.dataset.dsbr || this.dataset.dsbr !== "true")) {
          return -1;
        } else if (b.createdAtDate > a.createdAtDate)
          return 1
        else
          return 0;
      });
      return reviews;
    }

    storageSet(key, value) {
      sessionStorage.setItem(key, value);
      return true;
    }

    setBusinessUnitId(businessUnitId) {
      window.trustpilot.businessUnitId = businessUnitId;
      return true;
    }
  }
  class TrustpilotRatingWidget extends TrustpilotWidget {
    constructor() {
      super();
      this.init.then(() => {
        this.addEventListener('click', () => {
          window.open(`https://www.trustpilot.com/review/${window.trustpilot.websiteUrl}`, '_blank')
        });
        this.srcs = window.trustpilot.starSrcs;
        this.trustScore = this.querySelector('.trustpilot__trust-score');
        this.reviewsCount = this.querySelector('.trustpilot__reviews-count');
        this.stars = this.querySelector('.trustpilot__stars');
        const globalTrustScore = sessionStorage.getItem('global-trust-score');
        this.setRating(JSON.parse(globalTrustScore));
      });
    }

    setRating(data) {
      if (!data) return false;
      if (data?.score?.trustScore && data?.numberOfReviews?.total && data?.score?.stars) {
        this.trustScore.innerHTML = data.score.trustScore;
        this.reviewsCount.innerHTML = data.numberOfReviews.total;
        this.stars.srcset = this.srcs[data.score.stars.toString()].srcset;
        this.stars.src = this.srcs[data.score.stars.toString()].src;
        this.stars.style.opacity = "1";
      }
      return true;
    }
  }

  customElements.define('trustpilot-rating-widget', TrustpilotRatingWidget);

  class TrustpilotReviewWidget1 extends TrustpilotWidget {
    constructor() {
      super();
      this.init.then(() => {
        this.itemsBody = this.querySelector(".tp-reviews-1__body");
        this.getReviews(60).then(this.showReviews.bind(this));
      });
    }

    showReviews(reviews) {
      if (reviews.length > 3) {
        for (const review of reviews) {

          this.itemsBody.innerHTML = this.itemsBody.innerHTML + `
              <div class="tp-reviews-1__item">
                <div class="tp-reviews-1__item__title">${review.consumer && review.consumer.displayName ? review.consumer.displayName : review.title}</div>
                <div class="tp-reviews-1__item__star-rating"><img class="trustpilot__stars" srcset="${window.trustpilot.starSrcs[review.stars.toString()].srcset}" src="${window.trustpilot.starSrcs[review.stars.toString()].src}" width="68" height="12.75" loading="lazy"><span class="tp-reviews-1__item__rating">${Number.isInteger(review.stars) ? review.stars + ".0" : review.stars}</span></div>
                <div class="tp-reviews-1__item__text">${review.text}</div>
              </div>
            `
        }
      }
    }
  }

  customElements.define('trustpilot-review-widget-1', TrustpilotReviewWidget1);

  class TrustpilotReviewWidget2 extends TrustpilotWidget {
    constructor() {
      super();

      this.init.then(() => {
        this.itemsBody = this.querySelector(".tp-reviews-2__body");
        this.itemsDots = this.querySelector(".slider-dots");
        this.sliderComponent = this.querySelector("slider-component");
        this.reviewsLimit = 20;
        if (this.dataset.reviewsLimit) {
          this.reviewsLimit = parseInt(this.dataset.reviewsLimit);
        }

        this.getReviews(this.reviewsLimit).then(this.showReviews.bind(this))
      });
    }

    showReviews(reviews) {
      if (reviews.length > 3) {
        const consumerIds = [];
        for (const review of reviews) {
          consumerIds.push(review.consumer.id);
        }
        fetch(`https://api.trustpilot.com/v1/consumers/profile/bulk?apikey=${window.trustpilot.apiKey}`,
          {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ "consumerIds": consumerIds })
          })
          .then(response => response.json())
          .then(consumers => this.getConsumer(consumers, reviews));
      }
    }

    sortReviewsByImg(consumers, reviews) {
      reviews.sort((a, b) => {
        const aConsumer = consumers[a.consumer.id];
        if (aConsumer && aConsumer.hasImage && a.stars > 4)
          return -1;
        else if (consumers[b.consumer.id] && consumers[b.consumer.id].hasImage && b.stars > 4)
          return 0;
        else
          return 1;
      });
      return reviews;
    }

    getConsumer(data, reviews) {
      const consumers = data.consumers;
      let first = 0;
      this.itemsBody.innerHTML = "";
      this.itemsDots.innerHTML = "";
      reviews = this.sortReviewsByImg(consumers, reviews);
      for (const review of reviews) {
        this.itemsDots.innerHTML = this.itemsDots.innerHTML + `<li class="dot${first === 0 ? " is-selected" : ""}"></li>`;
        first++;
        const userDisplayName = consumers[review.consumer.id].displayName.split(" ");
        let userInitials = "";
        for (const namePart of userDisplayName) {
          if (namePart.length > 0)
            userInitials += namePart[0].toUpperCase();
        }
        let userImage = `<div class="tp-reviews-2__item-user-initials">${userInitials}</div>`;
        if (consumers[review.consumer.id].hasImage) {
          userImage = `<img class="tp-reviews-2__item-user-image" src="${consumers[review.consumer.id].profileImage['image73x73'].url}" alt="${consumers[review.consumer.id].displayName}" width="73" height="73" loading="lazy">`;
        }
        this.itemsBody.innerHTML = this.itemsBody.innerHTML + `
          <li class="tp-reviews-2__item slider__slide slider__slide--full-width">
            <div class="tp-reviews-2__item-wrapper">
              <div class="tp-reviews-2__item-user">
                ${userImage}
                <h3>${review.consumer && review.consumer.displayName ? review.consumer.displayName : review.title}</h3>
                <div class="tp-reviews-2__item-rating">
                  <img
                    class="trustpilot__logo"
                    srcset="${window.trustpilot.logoSrcset}"
                    src="${window.trustpilot.logoSrc}"
                    sizes="78px"
                    loading="lazy"
                    width="78"
                    height="19.5"
                    alt="Trustpilot logo"
                  >
                  <div class="tp-reviews-2__item__star-rating"><span class="tp-reviews-2__item__rating">${Number.isInteger(review.stars) ? review.stars + ".0" : review.stars}</span><img srcset="${window.trustpilot.starSrcs[review.stars.toString()].srcset}" src="${window.trustpilot.starSrcs[review.stars.toString()].src}" width="68" height="12.75" loading="lazy"></div>
                </div>
              </div>
              <div class="tp-reviews-2__item-text">
                <p>${review.text.slice(0, 60)}${review.text.length > 60 ? "..." : ""}
                ${review.text.length > 60 ? `<span><a href="https://www.trustpilot.com/reviews/${review.id}">more</a></span>` : ""}
                </p>
              </div>
            </div>
          </li>
        `;
      }
      if (this.dataset.loadMoreUrl && this.dataset.loadMoreText) {
        this.itemsDots.innerHTML = this.itemsDots.innerHTML + `<li class="dot${first === 0 ? " is-selected" : ""}"></li>`;
        this.itemsBody.innerHTML = this.itemsBody.innerHTML + `
            <li class="tp-reviews-2__item slider__slide slider__slide--full-width slider__slide__load-more-link">
              <a class="link underlined-link" href="${this.dataset.loadMoreUrl}">${this.dataset.loadMoreText}</a>
            </li>
          `;
      }
      this.sliderComponent.updateSliderContent();
    }
  }

  customElements.define('trustpilot-review-widget-2', TrustpilotReviewWidget2);

  /*
    This module totally needs intensive refactoring
  */
  class TestimonialsReviews extends TrustpilotWidget {
    constructor() {
      super();
      this.articlesPerPage = parseInt(this.dataset.reviewsCount);
      this.articles = [];
      this.articlesNextPage = null;
      this.blogHandles = this.dataset.blogHandles.split(",");
      this.handleIndex = 0;
      this.pageNum = 1;

      this.articleSample = this.querySelector(".article");

      this.init.then(this.getPage.bind(this)).then(() => {
        this.articleSample.parentElement.innerHTML = "";
        this.articleSample.classList.remove("hidden");
      }).then(this.displayPage.bind(this, this.pageNum)).then(() => this.pageNum++);
      this.tagButtons = this.querySelectorAll(".blog-tag");

      this.reviewsGrid = this.querySelector(".testimonials-reviews__grid");
      this.gridWrapper = this.querySelector(".testimonials-reviews__grid__wrapper");
      this.loadmoreBtn = this.querySelector("button[data-load-more]");
      this.gradient = this.querySelector(".tr__gradient");

      this.loadmoreBtn.addEventListener("click", this.loadMore.bind(this));

      this.tagButtons.forEach((btn) => {
        btn.addEventListener("click", this.changeTag.bind(this, btn));
      });
    }

    recalculateHeight() {
      const gridHeight = this.reviewsGrid.clientHeight;
      const wrapperHeight = this.gridWrapper.clientHeight;

      if (wrapperHeight >= gridHeight) {
        this.gradient.classList.add("hidden");
        this.gridWrapper.style.height = gridHeight + "px";
      } else {
        this.gradient.classList.remove("hidden");
        if (gridHeight < screen.height) {
          this.gridWrapper.style.height = gridHeight + "px";
        } else if (screen.width > 768) {
          this.gridWrapper.style.height = screen.height + "px";
        } else {
          // Keep bigger height for mobile
          this.gridWrapper.style.height = screen.width * 7 + "px";
        }
      }
    }

    loadMore() {
      const gridHeight = this.reviewsGrid.clientHeight;
      const wrapperHeight = this.gridWrapper.clientHeight;
      let newWrapperHeight = wrapperHeight * 2;

      if (newWrapperHeight > gridHeight) {
        newWrapperHeight = gridHeight;
        this.gradient.classList.add("hidden");
      }

      this.gridWrapper.style.height = newWrapperHeight + "px";
    }

    changeTag(btn) {
      this.tagButtons.forEach((tagButton) => {
        if (tagButton.dataset.href === btn.dataset.href) {
          tagButton.classList.add("active");
        } else {
          tagButton.classList.remove("active");
          this.reviewsGrid.classList.remove(`tag-${tagButton.dataset.href}`);
        }
      });
      this.reviewsGrid.classList.add(`tag-${btn.dataset.href}`);
      this.recalculateHeight();
    }

    generateBlogUrl(handle) {
      if (this.articlesNextPage)
        return this.articlesNextPage;
      if (!handle)
        return null;
      return `/blogs/${handle}` + (this.dataset.filterByTag ? `/tagged/${this.dataset.filterByTag}` : "") + `?view=json`;
    }

     getPage() {
      return new Promise(resolve => {
        this.getArticles(this.generateBlogUrl(this.blogHandles[this.handleIndex]), this.articlesPerPage * this.pageNum)
          .then(this.getReviews.bind(this, this.articlesPerPage)).then(resolve);
      });
    }

    getArticles(url, targetLength) {
      return new Promise(resolve => {
        if (!url) {
          resolve([]);
        } else {
          fetch(url)
            .then(response => {
              return response.ok ? response.json() : null;
            })
            .then(data => {
              if (data) {
                this.articlesNextPage = null;

                if (data.blogs)
                  this.articles.push(...data.blogs);

                if (data.next_page_url)
                  this.articlesNextPage = data.next_page_url;

                if (!this.articlesNextPage && this.blogHandles.length > this.handleIndex + 1) {
                  this.handleIndex += 1;
                  this.articlesNextPage = this.generateBlogUrl(this.blogHandles[this.handleIndex]);
                }

                if (data.blogs.length < targetLength && this.articlesNextPage) {
                  this.getArticles(this.articlesNextPage, targetLength).then(b => { resolve(b) });
                }
                else
                  resolve(data.blogs);
              } else {
                resolve([]);
              }
            })
            .catch(e => {
              if (this.blogHandles.length > this.handleIndex + 1) {
                this.handleIndex += 1;
                this.articlesNextPage = this.generateBlogUrl(this.blogHandles[this.handleIndex]);
                this.getArticles(this.articlesNextPage, targetLength).then(b => { resolve(b) });
              } else {
                console.error(e);
                resolve([]);
              }
            });
        }
      });
    }

    displayPage(pageNum = 1) {
      const reviewArticleRatio = parseInt(this.reviews.length / this.articles.length);

      for (let i = (pageNum - 1) * this.articlesPerPage; i < pageNum * this.articlesPerPage; i++) {
        if (this.articles.length > 0 && i % reviewArticleRatio === 0) {
          const article = this.articles.shift();
          if (article.testimonials_video)
            this.displayVideoArticle(article);
          else if (article.testimonials_image)
            this.displayArticleWithImage(article);
          else
            this.displayArticle(article);
        }

        if (this.reviews.length > 0 && i !== pageNum * this.articlesPerPage - 1)
          this.displayReview(this.reviews.shift());
      }
    }

    displayReview(review) {
      const reviewEl = document.createElement("div");
      reviewEl.classList.add("tr__review-item");
      reviewEl.innerHTML = `
        <h3 class="tr__review-item__title">${review.consumer && review.consumer.displayName ? review.consumer.displayName : review.title}</h3>
        <p class="tr__review-item__text">${review.text.slice(0, 315)}${review.text.length > 315 ? "..." : ""}
          ${review.text.length > 315 ? `<span><a href="https://www.trustpilot.com/reviews/${review.id}">more</a></span>` : ""}
        </p>
        <img class="tr__review-item__rating" srcset="${window.trustpilot.starSrcs[review.stars.toString()].srcset}" src="${window.trustpilot.starSrcs[review.stars.toString()].src}" width="108" height="20" loading="lazy">
      `;
      this.reviewsGrid.appendChild(reviewEl);
    }

    generateImageHTML(img, classes) {
      let width = 50;
      let result = "";
      let replacer = /\.[a-zA-Z]*\?/g;
      while (width < img.width && width <= 450) {
        result += img.src.replace(replacer, `_${width}x$&`) + ` ${width}w,`;
        width += 50;
      }
      result += `${img.src} ${img.width}w`;

      return `
        <img
        srcset="${result}"
        src="${img.width > 410 ? img.src.replace(replacer, `_410x$&`) + ` 410w` : img.src}"
        sizes="(min-width: 1450px) 410px, (min-width: 1025px) calc((100vw - 160px) / 3), (min-width: 769px) calc((100vw - 160px) / 2), calc(100vw - 32px)"
        alt="${img.alt}"
        width="${img.width}"
        height="${img.height}"
        loading="lazy"
        class="${classes}"
        >
      `;
    }

    displayArticle(article) {
      const articleEl = this.articleSample.cloneNode(true);
      const imageHTML = this.generateImageHTML(article.image, "motion-reduce");
      articleEl.querySelector("a").href = article.url;
      articleEl.querySelector(".article-card__image").innerHTML = imageHTML;
      articleEl.querySelector(".article-card__title").innerHTML = article.title;
      articleEl.querySelector(".article-card__excerpt").innerHTML = article.excerpt_or_content_stripped_truncated;

      for (const tag of article.tags) {
        const parts = tag.split(":");
        if (parts[0] === "length" && parts.length > 1) {
          const articleLengthSpan = articleEl.querySelector("span[data-article-length]");
          articleLengthSpan.innerHTML = parts[1] + " " + articleLengthSpan.innerHTML;
        }
      }

      this.reviewsGrid.appendChild(articleEl);

    }

    displayArticleWithImage(article) {
      const articleEl = document.createElement("div");
      const imageHTML = this.generateImageHTML(article.testimonials_image, "article-card__image-wrapper");
      articleEl.classList.add("article-card--3-2", "article-card--3-2--photo");

      articleEl.innerHTML = `
        <a href="${article.url}">
          <div class="article-card__shaddow-wrapper"></div>
          ${imageHTML}
          <h2 class="article-card__title">
            ${article.title}
          </h2>
        </a>
      `;

      this.reviewsGrid.appendChild(articleEl);
    }

    displayVideoArticle(article) {
      const articleEl = document.createElement("div");
      const videoBannerEl = document.createElement("div");
      articleEl.classList.add("article-card--3-2", "article-card--3-2--video");
      videoBannerEl.classList.add("video-banner__fullscreen");
      videoBannerEl.id = `video-fullscreen-${article.id}`;

      const postImage = article.testimonials_image ? article.testimonials_image : article.image;

      articleEl.innerHTML = `
        <div class="article-card__shaddow-wrapper"></div>
        <img class="article-card__image-wrapper" src="${postImage.src}" width="${postImage.width}" height="${postImage.height}" loading="lazy" />
        <button data-video-id="video-fullscreen-${article.id}" class="video-play-pause paused"></button>
        <h2 class="article-card__title">
          ${article.title}
        </h2>
      `;

      videoBannerEl.innerHTML = `
        <video-component data-debug="true" data-fullscreen="true" class="video-banner__video">
          <div class="video-close"><span></span></div>
          <video controls data-src="${article.testimonials_video}">
            Your browser does not support the video tag.
          </video>
        </video-component>
      `;
      this.reviewsGrid.appendChild(articleEl);
      this.reviewsGrid.appendChild(videoBannerEl);

      const playButton = articleEl.querySelector("button.video-play-pause");

      playButton.addEventListener("click", window.openFullscreenVideo);
    }
  }

  customElements.define('testimonials-reviews', TestimonialsReviews);
}
